import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { userAPI } from '../../services/api';
import { useAuth } from '../context/AuthContext';
import '../../styles/admin/CreateUser.css';


const CreateUser = () => {
    const { user } = useAuth();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        username: '',
        password: '',
        email: '',
        phone: '',
        role: 'user'
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const getAvailableRoles = () => {
        const roles = {
            admin: ['super_master', 'master', 'agent', 'user'],
            super_master: ['master', 'agent', 'user'],
            master: ['agent', 'user'],
            agent: ['user']
        };
        return roles[user?.role] || [];
    };

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            await userAPI.createUser(formData);
            alert('User created successfully!');
            navigate('/users');
        } catch (error) {
            setError(error.response?.data?.message || 'Error creating user');
        } finally {
            setLoading(false);
        }
    };

    const availableRoles = getAvailableRoles();

    return (
        <div className="create-user">
            <h1>Create New User</h1>
            
            {error && (
                <div className="alert alert-danger">{error}</div>
            )}
            
            <form onSubmit={handleSubmit} className="create-form">
                <div className="form-group">
                    <label>Username *</label>
                    <input
                        type="text"
                        name="username"
                        value={formData.username}
                        onChange={handleChange}
                        required
                        disabled={loading}
                        placeholder="Enter username"
                    />
                </div>
                
                <div className="form-group">
                    <label>Password *</label>
                    <input
                        type="password"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        required
                        disabled={loading}
                        placeholder="Enter password"
                    />
                </div>
                
                <div className="form-group">
                    <label>Email *</label>
                    <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        disabled={loading}
                        placeholder="Enter email"
                    />
                </div>
                
                <div className="form-group">
                    <label>Phone *</label>
                    <input
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                        disabled={loading}
                        placeholder="Enter phone number"
                    />
                </div>
                
                <div className="form-group">
                    <label>Role *</label>
                    <select
                        name="role"
                        value={formData.role}
                        onChange={handleChange}
                        required
                        disabled={loading}
                    >
                        {availableRoles.map(role => (
                            <option key={role} value={role}>
                                {role.replace('_', ' ').toUpperCase()}
                            </option>
                        ))}
                    </select>
                </div>
                
                <div className="form-actions">
                    <button 
                        type="button" 
                        className="btn btn-secondary"
                        onClick={() => navigate('/users')}
                        disabled={loading}
                    >
                        Cancel
                    </button>
                    <button 
                        type="submit" 
                        className="btn btn-primary"
                        disabled={loading}
                    >
                        {loading ? 'Creating...' : 'Create User'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default CreateUser;